import { render, staticRenderFns } from "./ActiveEvents.vue?vue&type=template&id=060967df&"
import script from "./ActiveEvents.vue?vue&type=script&lang=js&"
export * from "./ActiveEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports